import { notification } from 'antd';
import { useContext } from 'react';
import { AppContext } from 'App.context';
import { ApiContext } from 'utils/networking/Api.context';

export function showNoPermissionNotification(translate, API, action, subaction, data) {
  const safeTranslate = typeof translate === 'function' ? translate : key => key;

  notification.error({
    message: safeTranslate('noPermission.title'),
    description: safeTranslate('noPermission.description'),
    placement: 'topRight',
    duration: 10,
  });

  const safeAPI =
    API || (typeof window !== 'undefined' && window.__APP_API__ ? window.__APP_API__ : null);

  if (safeAPI && typeof safeAPI.registerDashboardAction === 'function') {
    try {
      safeAPI.registerDashboardAction(action, subaction, data);
    } catch (err) {
      console.warn('registerDashboardAction error:', err);
    }
  }
}

export function useShowNoPermissionNotification() {
  const { appActions } = useContext(AppContext) || {};
  const { API } = useContext(ApiContext) || {};

  const translate =
    appActions && typeof appActions.translate === 'function' ? appActions.translate : key => key;

  return (action, subaction, data, overridenTranslate, overridenAPI) => {
    const t = typeof overridenTranslate === 'function' ? overridenTranslate : translate;
    const api = overridenAPI || API;
    showNoPermissionNotification(t, api, action, subaction, data);
  };
}

export default showNoPermissionNotification;
